import { render, staticRenderFns } from "./dealerDetail.vue?vue&type=template&id=284b7f84&scoped=true"
import script from "./dealerDetail.vue?vue&type=script&lang=js"
export * from "./dealerDetail.vue?vue&type=script&lang=js"
import style0 from "./dealerDetail.vue?vue&type=style&index=0&id=284b7f84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284b7f84",
  null
  
)

export default component.exports